document.addEventListener('DOMContentLoaded', function () {
    const langWrapper = document.getElementById('primeLang');
    const langBtn = document.getElementById('primeLangBtn');

    if (langWrapper && langBtn) {
        langBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            langWrapper.classList.toggle('is-open');
            langBtn.setAttribute(
                'aria-expanded',
                langWrapper.classList.contains('is-open') ? 'true' : 'false'
            );
        });

        document.addEventListener('click', function () {
            langWrapper.classList.remove('is-open');
            langBtn.setAttribute('aria-expanded', 'false');
        });
    }

    const mobileBtn = document.getElementById('primeMobileMenuBtn');
    const mobileMenu = document.getElementById('primeMobileMenu');

    if (mobileBtn && mobileMenu) {
        mobileBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            mobileMenu.classList.toggle('is-open');
            mobileBtn.setAttribute(
                'aria-expanded',
                mobileMenu.classList.contains('is-open') ? 'true' : 'false'
            );
        });

        document.addEventListener('click', function (e) {
            if (!mobileMenu.contains(e.target) && !mobileBtn.contains(e.target)) {
                mobileMenu.classList.remove('is-open');
                mobileBtn.setAttribute('aria-expanded', 'false');
            }
        });
    }
});
